import classNames from "classnames";
import Image, { type ImageProps } from "~/components/common/Image";

const IMAGE_HEIGHT = 32;
const IMAGE_WIDTH = 32;

export type TileContentProps = {
  readonly description?: string;
  readonly descriptionId?: string;
  readonly title?: string;
  readonly image?: ImageProps;
};

const TileContent = ({
  title,
  description,
  image,
  descriptionId,
}: TileContentProps) => {
  return (
    <div
      className={classNames("h-full flex flex-col", {
        "gap-y-kern-space-small max-w-[calc(100%-1.5rem)]": image,
      })}
    >
      <div className="flex flex-row justify-between">
        {image && (
          <Image
            {...image}
            width={IMAGE_WIDTH}
            height={IMAGE_HEIGHT}
            ariaHidden={true}
          />
        )}
      </div>
      <div>
        {title && <h2 className="kern-body kern-body--bold">{title}</h2>}
        {description && (
          <p id={descriptionId} className="kern-body kern-body--muted">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default TileContent;
